import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../../__root";

/** Pathless layout: authenticated hub at `/`, `/account`, `/opt-in`. */
export const hubLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "hub",
}).lazy(() => import("./PortalLayout.lazy").then((d) => d.Route));
